import { render, staticRenderFns } from "./DashInstrutor.vue?vue&type=template&id=a5691ebc&scoped=true"
import script from "./DashInstrutor.vue?vue&type=script&lang=js"
export * from "./DashInstrutor.vue?vue&type=script&lang=js"
import style0 from "./DashInstrutor.vue?vue&type=style&index=0&id=a5691ebc&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5691ebc",
  null
  
)

export default component.exports